export default __webpack_public_path__ + "static/logoWhite-6eafe31f63a1833e2cb67e3300b4401d.png";